<template>
  <v-card flat>
    <slot name="cardTitle"></slot>
    <v-card-text>
      <v-form ref="form">
        <v-autocomplete
            v-if="showCardActions"
            v-model="regInfo.webinarId"
            :items="webinars"
            item-value="id"
            item-text="name"
            :rules="[v => !!v]"
            label="Вебинар"
            no-data-text="Актуальные вебинары не найдены"
        >
          <template #item="{item}">
            {{ item.name + ' [' + date(item.date) + ']' }}
          </template>
        </v-autocomplete>
        <v-autocomplete
            v-if="!showCardActions"
            v-model="regInfo.webinars"
            :items="webinars"
            item-value="id"
            item-text="name"
            multiple
            label="Вебинар"
            placeholder="Выберите вебинар"
            :rules="[v => v.length > 0]"
            return-object
            no-data-text="Актуальные вебинары не найдены"
        >
          <template #selection="{ item }">
            <v-chip
                outlined
                color="primary"
                close
                close-icon="mdi-close"
                @click:close="removeWebinar(item.id)"
            >
              <span>{{ item.name }}</span>
            </v-chip>
          </template>
        </v-autocomplete>
        <v-autocomplete
            v-model="regInfo.regionSubjectId"
            :items="regions"
            item-value="code"
            item-text="name"
            :rules="[v => !!v]"
            label="Субъект (Регион)"
            no-data-text="Нет данных"
        ></v-autocomplete>
        <v-autocomplete
            v-model="regInfo.organizationId"
            :items="organizations"
            item-value="code"
            item-text="name"
            :rules="[v => !!v]"
            label="Организация"
            no-data-text="Организаций не найдено"
        ></v-autocomplete>
        <person-card v-if="!loadedInfo" ref="personCard"></person-card>
        <v-text-field v-model="regInfo.position" label="Занимаемая должность" :rules="[v => !!v]" />
      </v-form>
    </v-card-text>
    <v-card-actions v-if="showCardActions">
      <v-spacer />
      <v-btn
          outlined
          color="primary"
          @click="close"
      >
        Отмена
      </v-btn>
      <v-btn
          outlined
          color="primary"
          @click="save"
      >
        Сохранить
      </v-btn>
    </v-card-actions>
  </v-card>

</template>

<script>
import PersonCard from "@/components/forms/PersonCard"
import { dateMixin, dbMixin, formsMixin, registerMixin } from "@/mixins"

export default {
  name: "WebinarForm",
  components: { PersonCard },
  mixins: [dbMixin, dateMixin, registerMixin, formsMixin],
  data () {
    return {
      role: 'webinarParticipant',
      organizations: [],
      regions: [],
      webinars: [],
      regInfo: {
        organizationId: '',
        regionSubjectId: '',
        webinarId: '',
        webinars: [],
        surname: '',
        firstname: '',
        patronymic: '',
        phone: '',
        email: '',
        degree: '',
        position: ''
      }
    }
  },
  beforeMount () {
    this.getCatalogData('regions')
    this.getCatalogData('organizations')
    this.getCatalogData('webinars', { isActual: true })
  },

  methods: {
    close () {
      this.$emit('close')
    },
    removeWebinar (webinarId) {
      this.regInfo.webinars = this.regInfo.webinars.filter(el => el.id != webinarId)
    }
  }
}
</script>

<style scoped>

</style>